/*
========================================================
STRIPE BILLING CONSTANTS
--------------------------------------------------------
Purpose:
- Central place for billing plan labels and descriptions
- Keeps UI text consistent across billing pages
========================================================
*/

export const BILLING_PLANS = [
  {
    key: "basic",
    title: "Basic",
    priceLabel: "Monthly plan",
    description: "Core workspace access for smaller teams.",
  },
  {
    key: "pro",
    title: "Pro",
    priceLabel: "Monthly plan",
    description: "Expanded features and more operational capacity.",
  },
  {
    key: "enterprise",
    title: "Enterprise",
    priceLabel: "Monthly plan",
    description: "Advanced scale, controls, and future premium modules.",
  },
];
